import { computed, inject, Injectable, signal } from "@angular/core";
import { ChildDto } from "@malirang/api-client";
import { LocalStorageService } from "@malirang/front-share";
import { LP_AUTH_KEY } from "../libs/http-interceptor";

@Injectable({ providedIn: "root" })
export class AuthStore {
    private readonly localStorageService = inject(LocalStorageService);
    childId = computed(() => this.child()?.id || null);

    private readonly _token = signal<string | null>(null);
    token = computed(() => this._token());

    private readonly _child = signal<ChildDto | null>(null);
    child = computed(() => this._child());

    setChild(child: ChildDto) {
        this._child.set(child);
    }

    async logout() {
        this._token.set(null);
        this._child.set(null);
        await this.localStorageService.remove(LP_AUTH_KEY);
    }
}
